import { Fragment } from "react";
import styled from "styled-components";

import { colors } from "../../../styles/figmaColors";
import { typographies } from "../../../styles/figmaTypographies";
import { StyledColumn, StyledFlex } from "./layout";
import { Spacer } from "../Spacer";
import { TextCapitalized } from "../text/TextCapitalized";

export interface FilterChipsProps {
  options: string[];
  selected: string;
  onSelect: (option: string) => void;
}

export const FilterChips = ({
  options,
  selected,
  onSelect,
}: FilterChipsProps) => (
  <StyledFilterChips>
    {options.map((option, index) => (
      <Fragment key={option}>
        {index > 0 && <Spacer x={0.5} />}
        <StyledChip
          as="button"
          onClick={() => onSelect(option)}
          $isSelected={option === selected}
        >
          <Spacer x={1} />
          <StyledColumn>
            <Spacer y={0.5} />
            <StyledLabel>
              <TextCapitalized>{option}</TextCapitalized>
            </StyledLabel>
            <Spacer y={0.5} />
          </StyledColumn>
          <Spacer x={1} />
        </StyledChip>
      </Fragment>
    ))}
  </StyledFilterChips>
);

const StyledFilterChips = styled(StyledFlex)`
  align-items: center;
  overflow-x: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const StyledChip = styled(StyledFlex)<{ $isSelected: boolean }>`
  /* Reset the native button chrome so spacing comes only from Spacer. */
  all: unset;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  /* Kept on both states so selection does not shift the row geometry. */
  border: 0.0625rem solid
    ${({ $isSelected }) =>
      $isSelected
        ? colors["colors/button/primary/default"]
        : colors["colors/borders/button/primary"]};
  border-radius: 25rem;
  background: ${({ $isSelected }) =>
    $isSelected
      ? colors["colors/button/primary/default"]
      : colors["colors/button/secondary/default"]};
  color: ${({ $isSelected }) =>
    $isSelected ? colors["colors/text/white"] : colors["colors/text/black"]};
  cursor: pointer;
`;

const StyledLabel = styled.span`
  ${typographies["Body/M"]}
  display: inline-block;
  white-space: nowrap;
`;
